'use client';

import { COMMON_UI_UTILS } from '@drift/common';
import { AccountOrder } from '../types';

interface TypeCellProps {
	order: AccountOrder;
}

export function TypeCell({ order }: TypeCellProps) {
	return <>{COMMON_UI_UTILS.getOrderLabelFromOrderDetails(order)}</>;
}
